<div class="avea-profile-validator"
     [ngClass]="validatorClasses()"
     fxLayout="row wrap"
     fxLayout.lt-md="column"
     fxLayoutGap="15px"
     fxFlex="100">

    <!--        -->
    <div class="avea-profile-info" fxFlex="50">

        <!-- Image-->
        <div class="profile-name">
            <h3>{{profile.profileName}}</h3>
        </div>

        <!--            -->
        <div class="profile-image">
            <img [src]="validationImage"
                 alt="Avea profile image">
        </div>

    </div>

    <!--    -->
    <div class="avea-profile-form-section" fxFlex>
        <form class="avea-profile-form"
              [formGroup]="validationFormGroup"
              fxLayout="column">

            <ng-container formArrayName="validationFields">


                <!--                -->
                <div class="form-group"
                     *ngFor="let group of validationFields?.controls ;let i=index ">

                    <ng-container dynamicField
                                  [fields]="validationFieldConfigs"
                                  [group]="group"></ng-container>
                </div>

            </ng-container>

            <!--       Submit Button             -->
<!--            <div class="validate-btn">-->
<!--                <button mat-flat-button-->
<!--                        type="button"-->
<!--                        (click)="onValidateProfile()"-->
<!--                        [color]="isDiscountApplied ? 'warn':'primary'">-->
<!--                    {{(isDiscountApplied ? 'shared.labels.discountApplied' : 'shared.labels.apply')|translate}}-->
<!--                </button>-->
<!--            </div>-->

        </form>
    </div>
</div>



